import {
    Box,
    Button,
    Container,
    Paper,
    Typography,
} from "@mui/material";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
// import SendEmail from "./SendEmail";
import guestIcon from "../../../images/guest.png"
import { useNavigate } from "react-router-dom";

export default function SelectGuest() {
        const navigate = useNavigate();
    // const [showGest, setShowGust] = useState(true);
    // const [selectType, setSelectType] = useState();
    const { t } = useTranslation();
    const handelSelecte = (e) => {
        if (e === "job") {
            navigate("job")
            // setSelectType("job");
            // setShowGust(false);
        } else if (e === "advertisement") {
            navigate("advertisement")
            // setSelectType("advertisement");
            // setShowGust(false);

        }
    }

    return (
        <>
        <Container className="mt-24 mb-10 flex justify-center">
                <Paper
                    sx={{
                        padding: "50px",
                        display: "flex"
                    }}
                >
                    <Box 
                     sx={{
                        padding: {md:"30px 50px"},
                        margin: "auto",
                    }}
                    >
                    <Typography
                        sx={{
                            marginTop: "20px",
                            fontSize: "20px",
                            textAlign: "center",
                            fontWeight: "700",
                            marginBottom: "20px",
                            color:"#3B82F6FC"
                        }}
                    >
                        {t("What type of ad do you want?")}
                    </Typography>
                    <Box sx={{
                       display: {md:"block",xs:"flex"},
                    }}>
                    <Button
                        variant="contained"
                        onClick={() => handelSelecte("advertisement")}
                        sx={{
                            textTransform: "capitalize",
                            margin: "15px",
                            color:"#fff",
                            fontWeight: "700",
                            height: { md: "50px" },
                            width: { md: "250px"},
                            backgroundColor: "#3B82F6FC"
                        }}
                    >
                        {t("Add Your Ad Here")}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => handelSelecte("job")}
                        sx={{
                            textTransform: "capitalize",
                            color:"#3B82F6FC",
                            margin: "15px",
                            width: { md: "250px" },
                            height: { md: "50px" },
                            fontWeight: "700",
                            cursor: "pointer",
                            backgroundColor: "#fff",
                            border: "3px solid #3B82F6FC"
                        }}
                    >
                        {t("Job")}
                    </Button>
                    </Box>
                    </Box>
                    <Box sx={{
                       display: {md:"block",xs:"none"}
                    }}>
                        <img src={guestIcon} alt={guestIcon} width={1500}/>
                    </Box>
                </Paper>
            </Container>
            {/* {showGest ? 
            <Container className="mt-24 mb-10 flex justify-center">
                <Paper
                    sx={{
                        padding: "50px",
                        display: "flex"
                    }}
                >
                    <Box 
                     sx={{
                        padding: "30px 50px",
                        margin: "auto",
                    }}
                    >
                    <Typography
                        sx={{
                            marginTop: "20px",
                            fontSize: "20px",
                            textAlign: "center",
                            fontWeight: "700",
                            marginBottom: "20px",
                            color:"#3B82F6FC"
                        }}
                    >
                        {t("What type of ad do you want?")}
                    </Typography>
                    <Button
                        variant="contained"
                        onClick={() => handelSelecte("advertisement")}
                        sx={{
                            textTransform: "capitalize",
                            margin: "15px",
                            color:"#fff",
                            fontWeight: "700",
                            width: { md: "250px" },
                            height: { md: "50px" },
                            backgroundColor: "#3B82F6FC"
                        }}
                    >
                        {t("Add Your Ad Here")}
                    </Button>
                    <Button
                        variant="contained"
                        onClick={() => handelSelecte("job")}
                        sx={{
                            textTransform: "capitalize",
                            color:"#3B82F6FC",
                            margin: "15px",
                            width: { md: "250px" },
                            height: { md: "50px" },
                            fontWeight: "700",
                            cursor: "pointer",
                            backgroundColor: "#fff",
                            border: "3px solid #3B82F6FC"
                        }}
                    >
                        {t("Job")}
                    </Button>
                    </Box>
                    <Box>
                        <img src={guestIcon} alt={guestIcon} />
                    </Box>
                </Paper>
            </Container> : <SendEmail type={selectType} />} */}
        </>

    );
}
